export enum SpecificCategoryEnum {
    MUNICIPALITY = "MUNICIPALITY",
    REGION = "REGION",
    VANS = "VANS",
    OTHER_STATE = "OTHER_STATE",
    OTHER_PRIVATE_HOSPITALS = "OTHER_PRIVATE_HOSPITALS",
    OTHER_FOREIGN_COUNTRIES = "OTHER_FOREIGN_COUNTRIES",
    OTHER_REGION = "OTHER_REGION",
    IT_VENDOR = "IT_VENDOR",
    IT_VENDOR_MUNICIPALITY = "IT_VENDOR_MUNICIPALITY",
    IT_VENDOR_MEDICAL_PRACTICE = "IT_VENDOR_MEDICAL_PRACTICE"
}